<template>
    <router-link :to="props.link ? props.link : ''">
        <button
            class="my-5 py-2 text-center font-medium text-2xl align-middle leading-10 cursor-pointer rounded shadow-lg"
            :style="'width: ' + props.width + '%;'"
            :class="
                colour == 'red' || colour == 'white'
                    ? colour == 'red'
                        ? 'bg-[#db0720] hover:bg-[#ce0720] text-white'
                        : 'bg-[#FFF] hover:bg-[#FAFAFA] text-black border-solid border-[1px] border-black'
                    : 'bg-[#0faedd] hover:bg-[#0fa4dd] text-white'
            "
            v-on:click="props.handleClick ? props.handleClick() : () => 1"
        >
            {{ props.title }}
        </button>
    </router-link>
</template>

<script lang="ts" setup>
    const props = defineProps({
        handleClick: Function,
        title: String,
        link: String,
        width: String,
        colour: String,
    })
</script>
